/*jslint browser: true, plusplus: true*/
/*global $, jQuery, alert, console*/

import URI from 'urijs';

import {sb_scrollWindowTo} from "../../utils/SchoolBlocks";
import NotificationManager from "../../components/notifications/NotificationManager";
import WatsonApi from "../../backends/WatsonApi";
import allStores from "../../stores/StoreLoader";
import {getCookieFromString} from "../../utils/StringUtilities";

export async function sb_pageSave(locale, orgID) {
    var page = $('.sb-page-container'),
        pageBody = $('#pageBody'),
        blockID = page.attr('data-id'),
        title = $('#pageTitle'),
        ajaxData;
    // produce a more user friendly error message as opposed to message coming back from
    // CHttpException(404,'Could not validate the content being saved.'); in the PageController.php
    if (pageBody.data('contentbuilder').html() == '')
    {
        NotificationManager.error("The page content cannot be empty.");

        return;
    }
    const token = getCookieFromString("token", document.cookie);

    // Call saveimages first because the images will be saved to the server and then the links updated in the HTML content.
    pageBody.saveimages({
        blockId: blockID,
        'handler': URI(`https://api.${process.env.NEXT_PUBLIC_APP_ENV}.cleversite.com/organizations/${allStores.organizationStore.currentOrganization.id}/pageblock/save_image/`),
        headers: {
            'api-key': token,
        },
        onComplete: async function () {
            var content = pageBody.data('contentbuilder').html();
            ajaxData = {
                'title': title.text(),
                'content': content,
            };
            try {
                const client = await WatsonApi()
                const response = await client.apis.organizations.organizations_ada_evaluate({
                    organization_pk: orgID,
                    accept: "text/html",
                    data: { source: content },
                });
                const result = response.data
                var $table = $($.parseHTML(result)[2]),
                    resultCount = $table.find('.result-count').text(),
                    resultType = $table.find('.result-type').text(),
                    tableHtml,
                    errors;

                if (!(resultCount==0)) {

                    // $table.addClass('table');
                    $table.find('#results-overview').parent().parent().remove();
                    $table.find('tr:not(:first)').find('td:eq(2)').each(function () {
                        $(this).html(function (index, oldHtml) {
                            return '<code>' + oldHtml + '</code>';
                        });
                    });
                    // Change 'Techniques' to 'Details'
                    $table.find('tr:first').find('th:eq(3)').text('Details');
                    // Change 'Details' link text to 'Click Here'
                    $table.find('tr:not(:first)').find('td:eq(3)').find('a').text('Click Here');
                    // remove 'Principles' column heading & column
                    $table.find('tr:first').find('th:eq(0)').remove();
                    $table.find('tr:not(:first)').find('td:eq(0)').remove();

                    tableHtml = $table.html();
                    window.sb_scrollWindowTo = sb_scrollWindowTo;

                    errors = '<span>This page had ' + resultCount + ' ' + resultType + '</span>' +
                        "<span>Click <a onclick=\"sb_scrollWindowTo(document.querySelector('#pageBody .ui-draggable:last-of-type'))\">here</a>" +
                        ' to learn more </span>';

                    $('.sb-ada-page-errors-count').html(errors);
                    $('.sb-ada-page-errors-table')
                        .find('.panel-heading > .label-danger').text(resultCount + ' ' + resultType)
                        .end()
                        .find('.table-responsive')
                        .html("<table id='test-results-table' class='table table-condensed'>" + tableHtml + "</table>")
                        .end()
                        .show();
                }
                try {
                    const response = client.apis.organizations.organizations_pageblock_update({
                        organization_pk: orgID,
                        id: blockID,
                        data: {...ajaxData},
                    });
                    if (response){
                        NotificationManager.success("Page saved successfully.");
                        //TODO: need to update the block on the main page if the save was successful
                    }
                }
                catch (e) {
                    console.log(e);
                    NotificationManager.error("Page failed to save.\nError: " + e.responseText);
                }
            }
            catch (e){
                NotificationManager.error("Failed to check page ADA compliance.\nError: " + e);
            }

        },
    });
    pageBody.data('saveimages').save();
}

export function sb_relocatePageToolbar() {
    var $toolbar = $('#rte-toolbar'),
        $pageContent = $('#sb-main-content'),
        $pageBody = $('#pageBody'),
        contentPosition = $pageContent.offset(),
        leftPosition,
        toolbarHeight = 518,
        viewportHeight = $(window).height(),
        contentEditor = $pageBody.data('contenteditor');

    if (contentEditor === undefined || contentEditor === null) {
        $toolbar.hide();
    } else {
        $toolbar.addClass('rte-side');
        contentEditor.settings.toolbar = 'left';
        contentEditor.settings.hasChanged = true;
        contentEditor.render();

        // try the vertical bar first
        leftPosition = contentPosition.left - $toolbar.width() - 16;
        $toolbar.css('left', leftPosition);
        $toolbar.css('top', contentPosition.top);

        if (viewportHeight < (contentPosition.top + toolbarHeight) ||
            leftPosition < 60) {
            // use a horizontal toolbar, not a vertical one
            $toolbar.removeClass('rte-side');
            contentEditor.settings.toolbar = 'top';
            contentEditor.settings.hasChanged = true;
            contentEditor.render();

            $toolbar.css('top', 0);
            $toolbar.css('left', 0);
        }
        $toolbar.show();
    }
}

